<template>
  <div style="position: relative">
    <a-upload
      name="upfile"
      :multiple="multiple"
      :action="uploadAction"
      :data="params"
      :fileList="showList"
      :beforeUpload="beforeUpload"
      :disabled="disabled"
      @change="handleChange"
    >
      <template>
        <a-button> <a-icon type="upload" />{{ text }} </a-button>
      </template>
    </a-upload>
  </div>
</template>

<script>
export default {
  name: 'JUpload',
  data() {
    return {
      uploadAction: `${window._CONFIG['domianURL']}/uploader`,
      params: {},
      headers: {},
      showList: [],
      resList: null
    }
  },
  computed: {
    // uploadAction() {
    //   console.log('aaa')
    //   return `${window._CONFIG['domianURL']}/uploader`;
    // },
  },
  props: {
    text: {
      type: String,
      required: false,
      default: '点击上传'
    },
    fileList: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    fileList: {
      handler(val) {
        if (this.multiple) {
          this.showList = [...val]
        } else {
          this.showList = val
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    beforeUpload(file) {
      var fileType = file.type
      this.params = {
        filename: file.name
      }
      return true
    },
    handleChange(info) {
      console.log('--文件列表改变--')
      let fileList = info.fileList
      if (info.file.status === 'done') {
        if (this.multiple) {
          this.resList = []
          this.resList.push(info.file.response.result)
        } else {
          this.resList = info.file.response.result
        }
        this.$emit('change', this.resList)
      }
      this.showList = fileList.slice(-1)
    }
  },

  model: {
    prop: 'value',
    event: 'change'
  }
}
</script>

<style lang="less">
.uploadty-disabled {
  .ant-upload-list-item {
    .anticon-close {
      display: none;
    }
    .anticon-delete {
      display: none;
    }
  }
}
//---------------------------- begin 图片左右换位置 -------------------------------------
.uploadty-mover-mask {
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0.8;
  color: #fff;
  height: 28px;
  line-height: 28px;
}
//---------------------------- end 图片左右换位置 -------------------------------------
</style>
